export default __webpack_public_path__ + "static/media/Bluefish-4.8a5f52cf.png";